import CompanyList from './CompanyList.vue'
export {CompanyList}
export default CompanyList

